import React, { useState } from "react";
import { Card, Button, Checkbox, Divider, message, Input } from "antd";
import { CheckOutlined, CloseOutlined, CopyOutlined } from "@ant-design/icons";

/**
 * PartnerCard — intermediate summary card shown when a table row is clicked.
 * Mirrors CorporateCard but:
 *   - Shows slug_name
 *   - Removes requires_employee_number
 *   - Only displays D2C type products in the Products list
 */
const PartnerCard = ({
  partnerDataInUpdate,
  setShowMiddleSection,
  setshowAddButton,
}) => {
  const [copied, setCopied] = useState(false);
  const [showWidgetLink, setShowWidgetLink] = useState(false);

  const handleCopy = () => {
    const value = partnerDataInUpdate?.widget_url;
    if (value) {
      navigator.clipboard.writeText(value);
      setCopied(true);
      message.success("Copied to clipboard!");
      setTimeout(() => setCopied(false), 2000);
    } else {
      message.warning("No widget URL available to copy");
    }
  };

  return (
    <Card
      style={{
        borderRadius: "10px",
        overflow: "hidden",
        padding: 0,
        backgroundColor: "#f0fafa",
        border: "none",
        width: "100%",
        maxWidth: "950px",
      }}
      bodyStyle={{ padding: 0 }}
    >
      {/* Header */}
      <div
        style={{
          backgroundColor: "#008385",
          color: "#fff",
          textAlign: "center",
          padding: "10px 0",
          fontWeight: "bold",
          fontSize: "16px",
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
          position: "relative",
        }}
      >
        {partnerDataInUpdate?.name}

        {/* Close Icon */}
        <CloseOutlined
          onClick={() => {
            setShowMiddleSection(false);
            setshowAddButton(true);
          }}
          style={{
            position: "absolute",
            right: 15,
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            fontSize: "16px",
            color: "#fff",
          }}
        />
      </div>

      {/* Body */}
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px 30px",
          borderBottomLeftRadius: "10px",
          borderBottomRightRadius: "10px",
          textAlign: "center",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        }}
      >
        {/* Action Buttons */}
        <div style={{ marginBottom: 10 }}>
          <Button
            type="default"
            onClick={() => {
              if (partnerDataInUpdate?.page_url) {
                window.open(partnerDataInUpdate.page_url, "_blank");
              } else {
                message.warning("No page URL available");
              }
            }}
            style={{
              marginRight: 10,
              backgroundColor: "#f5f5f5",
              borderRadius: "6px",
              border: "1px solid #d9d9d9",
              fontWeight: 500,
            }}
          >
            View page
          </Button>
          <Button
            type="default"
            onClick={() => setShowWidgetLink((prev) => !prev)}
            style={{
              backgroundColor: showWidgetLink ? "#0083851a" : "#f5f5f5",
              borderRadius: "6px",
              border: showWidgetLink
                ? "1px solid #008385"
                : "1px solid #d9d9d9",
              fontWeight: 500,
              color: showWidgetLink ? "#008385" : "inherit",
            }}
          >
            {showWidgetLink
              ? "Hide booking widget link"
              : "View booking widget link"}
          </Button>
        </div>

        <Divider style={{ margin: "10px 0" }} />

        {/* Widget URL toggle */}
        {showWidgetLink && (
          <div style={{ display: "flex", justifyContent: "center", marginBottom: 10 }}>
            <div style={{ width: "100%", maxWidth: "400px" }}>
              <Input
                suffix={
                  copied ? (
                    <span style={{ color: "green", fontSize: 12 }}>
                      <CheckOutlined /> Copied
                    </span>
                  ) : (
                    <CopyOutlined
                      style={{ cursor: "pointer", color: "#1677ff" }}
                      onClick={handleCopy}
                    />
                  )
                }
                value={partnerDataInUpdate?.widget_url}
                style={{ width: "100%" }}
                placeholder="Booking widget link"
                disabled
              />
            </div>
          </div>
        )}

        {/* Products — D2C type only */}
        <div style={{ textAlign: "left", marginBottom: 20 }}>
          <strong>Products:</strong>
          <div>
            {partnerDataInUpdate?.corporate_products?.length > 0 ? (
              partnerDataInUpdate.corporate_products.map((product) => (
                <Checkbox key={product.non_gp_product_id} checked disabled>
                  {product.name}
                </Checkbox>
              ))
            ) : (
              <div style={{ color: "#999", fontSize: "14px" }}>
                No products added
              </div>
            )}
          </div>
        </div>

        {/* Company Email */}
        <div style={{ textAlign: "left", marginBottom: 20 }}>
          <strong>Company Email:</strong>
          <div
            style={{
              marginTop: 8,
              color: partnerDataInUpdate?.email ? "#000" : "#999",
            }}
          >
            {partnerDataInUpdate?.email || "N/A"}
          </div>
        </div>

        {/* Intranet URL */}
        {/* <div style={{ textAlign: "left", marginBottom: 20 }}>
          <strong>Intranet URL:</strong>
          <div
            style={{
              marginTop: 8,
              color: partnerDataInUpdate?.intranet_url ? "#000" : "#999",
            }}
          >
            {partnerDataInUpdate?.intranet_url || "N/A"}
          </div>
        </div> */}

        {/* Page URL */}
        {/* <div style={{ textAlign: "left", marginBottom: 20 }}>
          <strong>Page URL:</strong>
          <div
            style={{
              marginTop: 8,
              color: partnerDataInUpdate?.page_url ? "#000" : "#999",
            }}
          >
            {partnerDataInUpdate?.page_url || "N/A"}
          </div>
        </div> */}

        {/* Widget URL */}
        <div style={{ textAlign: "left", marginBottom: 20 }}>
          <strong>Widget id:</strong>
          <div
            style={{
              marginTop: 8,
              color: partnerDataInUpdate?.widget_url ? "#000" : "#999",
            }}
          >
            {partnerDataInUpdate?.widget_url || "N/A"}
          </div>
        </div>

        {/* Clinic Label */}
        <div style={{ textAlign: "left", marginBottom: 20 }}>
          <strong>Clinic Label:</strong>
          <div
            style={{
              marginTop: 8,
              color: partnerDataInUpdate?.clinic_label ? "#000" : "#999",
            }}
          >
            {partnerDataInUpdate?.clinic_label || "N/A"}
          </div>
        </div>

        {/* Hide Consultation Form */}
        <div style={{ textAlign: "left", marginBottom: 20 }}>
          <strong>Hide Consultation Form:</strong>
          <div style={{ marginTop: 8, color: "#000" }}>
            {partnerDataInUpdate?.hide_consultation_form ? "Yes" : "No"}
          </div>
        </div>

        {/* Allow Booking for CSR */}
        {/* <div style={{ textAlign: "left", marginBottom: 20 }}>
          <strong>Allow Booking for CSR:</strong>
          <div style={{ marginTop: 8, color: "#000" }}>
            {partnerDataInUpdate?.allow_for_admin ? "Yes" : "No"}
          </div>
        </div> */}

        {/* Change Category Label */}
        {/* <div style={{ textAlign: "left", marginBottom: 20 }}>
          <strong>Change Category Label:</strong>
          <div style={{ marginTop: 8, color: "#000" }}>
            {partnerDataInUpdate?.change_category_label ? "Yes" : "No"}
          </div>
        </div> */}

        {/* Product Category Label — conditional */}
        {partnerDataInUpdate?.change_category_label && (
          <div style={{ textAlign: "left", marginBottom: 20 }}>
            <strong>Product Category Label:</strong>
            <div
              style={{
                marginTop: 8,
                color: partnerDataInUpdate?.product_category_label
                  ? "#000"
                  : "#999",
              }}
            >
              {partnerDataInUpdate?.product_category_label || "N/A"}
            </div>
          </div>
        )}

        {/* NOTE: requires_employee_number is intentionally absent */}
      </div>
    </Card>
  );
};

export default PartnerCard;
